// Google Analytics configuration utility
// Helper function to get Google Analytics Measurement ID based on environment

export const getGAMeasurementId = () => {
  const currentUrl = window.location.href;
  
  // Production environment
  if (currentUrl.includes("main") || currentUrl.includes("valueinsightpro.jumpiq.com")) {
    return "G-VEJ3FF1VBF"; // Production Measurement ID
  }
  
  // Staging environment
  if (currentUrl.includes("staging")) {
    return "G-0YB6LPKGJK"; // Staging Measurement ID
  }
  
  // Dev environment (default for localhost and dev URLs)
  return "G-XLXHWTZ4QB"; // Dev Measurement ID
};

// Get the full Google Analytics dashboard URL for the current environment
export const getGADashboardUrl = () => {
  const gaPropertyId = getGAMeasurementId();
  return `https://analytics.google.com/analytics/web/#/p${gaPropertyId.replace('G-', '')}/reports/dashboard`;
};

